export const MAX_UPLOAD_FILES = 4;

// The 'Only JPG, JPEG, PNG, PDF and HEIC files are allowed.' toast still
// hardcodes the list — keep them in sync when this array changes.
export const ALLOWED_HIRE_FILE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf', 'image/heic'];

export const MAX_HIRE_FILE_SIZE_MB = 5;

export const MAX_HIRE_FILE_SIZE_BYTES = MAX_HIRE_FILE_SIZE_MB * 1024 * 1024;

/**
 * Markets the hire form supports in V1. The hire-variable `country` carries the
 * ISO code; the name is the English display label for the employment-country select.
 */
export const SUPPORTED_HIRE_COUNTRIES = [
  { code: 'NL', name: 'Netherlands' },
  { code: 'DE', name: 'Germany' },
] as const;

/**
 * Returns the given ISO code when it is a supported hiring market, or an empty
 * string so the required country control forces the admin to pick one.
 */
export function supportedHireCountryCode(code: string | null | undefined): string {
  return SUPPORTED_HIRE_COUNTRIES.find((country) => country.code === code)?.code ?? '';
}

/** The employment-category slug that should line up with a minijob-flagged contract type. */
export const MINIJOB_EMPLOYMENT_CATEGORY = 'minijob';

/** Phone country code used when the account has no configured country. */
export const DEFAULT_HIRE_REGION_CODE = 'NL';
